var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFingotiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,150) scale(0.1,-0.1)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197 1485 c-53 -20 -108 -62 -140 -106 -57 -79 -57 -78 -57 -629 0 -486 3 -553 30 -583 3 -4 66 52 138 124 l132 131 0 89 0 89 451 0 451 0 -4 -102 c-2 -87 -6 -108 -25 -134 -45 -63 -57 -65 -417 -65 l-325 0 -31 -25 c-60 -51 -239 -237 -235 -244 16 -27 107 -31 605 -28 l515 3 48 24 c60 31 110 81 139 140 23 46 23 49 26 561 3 500 -1 589 -28 605 -4 3 -67 -54 -139 -126 l-131 -131 0 -89 0 -89 -451 0 -451 0 4 103 c3 88 6 107 26 135 43 60 59 62 421 62 l328 0 132 131 c73 73 128 135 124 139 -30 27 -95 30 -587 29 -410 0 -518 -3 -549 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingotiIcon);
export default __webpack_public_path__ + "static/media/FingotiIcon.6df95e5cb1f8b1965b88345775e4512f.svg";
export { ForwardRef as ReactComponent };